import * as Actions from '../actions';
import _ from 'lodash';

const initialState = {
    preload: 0,
    statusXapp: null,
    data: {
        displayName: '',
        foto: '',
        email: '',
        settings: {},
        access_token: null,
    }
};

const user = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_USER_DATA:
            {
                return {
                    ...initialState,
                    ...action.payload,
                    access_token: action.access_token,
                    preload: 0,
                    statusXapp: action.status_xapp

                };
            }
        case Actions.REMOVE_USER_DATA:
            {
                return {
                    ...initialState,
                    preload: 0
                };
            }
        case Actions.USER_LOGGED_OUT:
            {
                return {
                    ...initialState,
                    preload: 0
                };
            }
        case Actions.SET_PRELOAD_AUTH:
            {
                return {
                    ...state,
                    preload: action.preload
                };
            }
        case Actions.SET_ORGANIZACOES:
            {
                return {
                    ...state,
                    organizacoes: action.preload
                };
            }
        default:
            {
                return state
            }
    }
};

export default user;